import { defineMessage } from 'services/localization';

export const messages = {
    dearButton: defineMessage('connect_to_cin_core'),
    netSuiteButton: defineMessage('connect_to_netsuite'),
    xeroButton: defineMessage('connect_to_xero'),
    qboButton: defineMessage('connect_to_quickbooks_online'),
};
